import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import BlogItem from "../components/blog-item"
import Seo from "../components/seo"

export default function StoryCategory({ data }) {
  const category = data.wpCategory
  return (
    <Layout>
      <Seo
        title={`${category.name}`}
        description={category.description}
        url={`${process.env.GATSBY_SITE_URL}/${category.slug}/`}
      />
      <header className="bg-white dark:bg-gray-900 dark:text-white  mb-12">
        <h5>Blog Category:</h5>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
          {category.name}
        </h1>
        <p>{category.description}</p>
      </header>
      <div
        className={"border-4 border-dashed border-gray-200 rounded-lg p-8 pb-0"}
      >
        {data.allWpPost.nodes.map(node => (
          <BlogItem key={node.slug} post={node} />
        ))}
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ($id: Int!) {
    allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { databaseId: { eq: $id } } } }
      }
    ) {
      nodes {
        ...post
      }
      distinct(field: commentCount)
    }
    wpCategory(databaseId: { eq: $id }) {
      name
      slug
      description
      count
    }
  }
`
